module.exports = __webpack_public_path__ + "static/media/loading.e64326c1.gif";


//////////////////
// WEBPACK FOOTER
// ./src/apps/portfolio/assets/loading.gif
// module id = 630
// module chunks = 2